<template>
  <div class="page wrapper pd-t-20 pd-b-20 pd-l-20 pd-r-20 cl-black-russian fz-14">
	<h1 class="pd-l-20 pd-r-20 tx-ct fz-26 fw-7">About</h1>
	<p>Even if you ignore the bad acting, shoddy scripts and mind-numbing music, Bollywood still does not fail to disappoint you. </p>
	<p>It is an industry of the nepokids, by the nepokids and will soon become for the nepokids. Unless you and I speak.</p>
	<p>It is time to tell them that we deserve better. Let’s rate the current and the up-and-coming movies on the nepometer scale.</p>
	<h5 class="mg-t-20">... In loving memory of Sushant Singh Rajput.</h5>
	<div class="footer">This app uses the TMDb API but is not endorsed or certified by TMDb.</div>
  </div>
</template>

<style>
	p {
		margin-top: 10px;
	}
	.footer {
		position: absolute;
		bottom: 40px;
		padding: 0 20px 0 0;
	}
</style>

<script>
	export default {
		title: 'About Nepometer'
	};
</script>